import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { ToastModule } from 'primeng/toast';
import { TextareaModule } from 'primeng/textarea';

import { AtividadeOsVinculada } from '../models/atividade-os-vinculada';
import { AtividadeOsVinculadaService } from './atividade-os-vinculada.service';

import { UserService } from '@/core/service/user.service';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'mf-atividade-os-vinculada',
    templateUrl: './atividade-os-vinculada.component.html',
    styleUrls: ['atividade-os-vinculada.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        DialogModule,
        TableModule,
        ButtonModule,
        SelectModule,
        ToastModule,
        TextareaModule
    ],
    providers: [MessageService]
})
export class AtividadeOsVinculadaComponent implements OnInit {
  atividadeOSsVinculadas: AtividadeOsVinculada[] = [];
  @Input() idAtividade: number = 0;
  idAtividadeSelecionada: number = 0;
  @Input() numeroBa: string = '';
  loading: boolean = false;
  public displayDialog: boolean = false;
  public url: string = '';
  visible: boolean = false;
  osComplementar: number = 0;
  comboComplementar: any;
  valueCombo: any;
  detailOsComplementar: any;
  obsAprComplementar: null | string = '';
  idEmpresa: number = 0;

  constructor(
    private atividadeOsVinculadaService: AtividadeOsVinculadaService,
    private userService: UserService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.getOSsVinculadas();
    this.getComboComplementar();
    this.idEmpresa = this.userService.getIdEmpresa();
  }

  getOSsVinculadas() {
    this.atividadeOsVinculadaService.getOSsVinculadas(this.idAtividade).subscribe((atvOSsVinculadas) => {
      this.atividadeOSsVinculadas = atvOSsVinculadas;
      this.loading = false;
    });
  }

  showDialog(value: any) {
    this.osComplementar = value.idAtividadeComplementar;
    this.displayDialog = true;
    this.atividadeOsVinculadaService.getOSComplementar(this.osComplementar).subscribe((res) => {
      this.detailOsComplementar = res;
    });
  }

  updOSComplementar() {
    if (!this.valueCombo) {
      this.messageService.add({
        severity: 'info',
        summary: 'Informação',
        detail: 'É necessário selecionar um status para tratamento de OS Complementar!',
      });
      return;
    }

    const body = {
      idAtividadeComplementar: this.osComplementar,
      status: this.valueCombo.text,
      observacaoAprovacao: this.obsAprComplementar,
      idEmpresaSelecionada: Number(this.idEmpresa),
    };

    this.atividadeOsVinculadaService.updOSComplementar(body).subscribe({
      next: (res) => {
        if(res.statusRetorno === 'OK') {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Solicitação de OS editada com sucesso!',
          });
          this.displayDialog = false;
          this.getOSsVinculadas();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: res.mensagemRetorno,
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Ocorreu um erro ao editar a solicitação de OS.',
        });
        this.displayDialog = false;
        this.getOSsVinculadas();
        // Erro na requisição
      },
    });

    this.valueCombo = null;
    this.obsAprComplementar = null;
  }

  getComboComplementar() {
    this.atividadeOsVinculadaService.getComboComplementar().subscribe((res) => {
      this.comboComplementar = res;
    });
  }
}
